import { Link, useLocation } from "react-router-dom";
import { Home, PlusSquare, User, Trophy, Compass } from "lucide-react";

const items = [
  { to: "/", icon: Home, label: "Reels", testid: "nav-reels" },
  { to: "/leaderboard", icon: Trophy, label: "Top", testid: "nav-leaderboard" },
  { to: "/upload", icon: PlusSquare, label: "Create", testid: "nav-upload", center: true },
  { to: "/more", icon: Compass, label: "Discover", testid: "nav-more" },
  { to: "/profile", icon: User, label: "Profile", testid: "nav-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 inset-x-0 z-40 max-w-md md:max-w-none mx-auto pointer-events-none">
      <div className="glass border-t border-white/10 px-2 pb-1 pt-1 flex items-center justify-around pointer-events-auto md:max-w-md md:mx-auto md:rounded-t-2xl" style={{ paddingBottom: "max(env(safe-area-inset-bottom), 4px)" }}>
        {items.map(({ to, icon: Icon, label, testid, center }) => {
          const active = pathname === to || (to !== "/" && pathname.startsWith(to));
          if (center) {
            return (
              <Link key={to} to={to} data-testid={testid} className="-mt-5">
                <div className={`w-11 h-11 rounded-2xl flex items-center justify-center bg-gradient-to-br from-[#00E5FF] to-[#FF2A5F] neon-cyan ${active ? "scale-105" : ""} active:scale-95 transition-transform`}>
                  <Icon className="w-5 h-5 text-black" strokeWidth={2.5} />
                </div>
              </Link>
            );
          }
          return (
            <Link key={to} to={to} data-testid={testid} className="flex flex-col items-center gap-0 px-2 py-0.5 active:scale-90 transition-transform">
              <Icon className={`w-4 h-4 ${active ? "text-[#00E5FF]" : "text-white/60"}`} strokeWidth={active ? 2.5 : 2} />
              <span className={`text-[9px] leading-tight ${active ? "text-[#00E5FF] font-semibold" : "text-white/50"}`}>{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
